// Standard library imports
import React, { useEffect, useState } from 'react';

// External library imports
import { toast } from 'react-toastify';
import moment from 'moment';
import _ from 'lodash';
// Internal module imports
import Table from '../../../../components/Table/Table';
import Typography from '../../../../components/Typography/Typography';
import DatePicker from '../../../../components/Inputs/DatePicker/DatePicker';
import { useLoader } from '../../../../hooks/use-loader.hook';

// Css imports
import classes from '../../../../styles/AllDevices.module.css';
import { momentTimeFormater } from '../../../../utils/dateHelper';
import { RootOcpiService } from '../../../../services/RootOcpiService';
import { Input, InputWithOutState } from '../../../../components/Inputs/Input';

const LIMIT = 15;

const Ocpilogs = ({ queryParamsData }) => {
    const [startLoader, stopLoader] = useLoader();
    const [data, setData] = useState([]);
    const [skip, setSkip] = useState(0);
    const [page, setPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [date, setDate] = useState(queryParamsData.date ? queryParamsData.date : new Date());
    const [search, setSearch] = useState('');

    useEffect(() => {
        getLogs();
    }, [date, skip]);

    const getLogs = () => {
        const params = {
            limit: LIMIT,
            skip,
            date: moment(date).format('YYYY-MM-DD'),
            search,
        };
        RootOcpiService.GetLogs(params, startLoader, handleSuccess, handleError, stopLoader);
    };

    const handleSuccess = ({ data }) => {
        const processedData = _.get(data, ['data', 'data'], []).map((item) => ({
            sessionId: item.sessionId,
            message: item.message,
            timestamp: momentTimeFormater(item.createdAt).format('YYYY-MM-DD HH:mm:ss'),
        }));
        setTotalCount(_.get(data, ['data', 'count'], 0));
        setData(processedData);
    };

    const handleError = (err) => {
        let data = err && err.response ? err.response.data : null;
        if (data) toast.error(data.message);
        else toast.error('Internal server error!');
    };

    const handlePageChange = (pageno) => {
        setSkip(LIMIT * pageno);
        setPage(pageno);
    };

    return (
        <div>
            <div className={classes.AllDevices} style={{ marginBottom: '2vh' }}>
                <div className={classes.Header}>
                    <div></div>
                    <div className={classes.InputContainer2}>
                        <div className={classes.FieldControl2}>
                            <div className={classes.BadgeContainer}>
                                <div>
                                    <label>Search Session Id</label>
                                    <InputWithOutState
                                        value={search}
                                        onChange={(e) => {
                                            setSearch(e.target.value);
                                        }}
                                        style={{ marginTop: '0' }}
                                        label="Enter Session Id"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className={classes.FieldControl2}>
                            <div className={classes.BadgeContainer}>
                                <div>
                                    <label>Date</label>
                                    <DatePicker date={date} setDate={setDate} showArrow={true} />
                                </div>
                            </div>
                        </div>

                        <button
                            type="submit"
                            className="btn-primary"
                            style={{
                                marginTop: '3vh',
                                width: 'auto',
                            }}
                            onClick={getLogs}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
            <div className={classes.AllDevices}>
                <div className={classes.Header}>
                    <div>
                        <Typography content={'OCPI Logs'} />
                        <div className={classes.TableCount}>
                            Total Count :
                            <span>
                                <Typography size="14" content={totalCount} />
                            </span>
                        </div>
                    </div>
                </div>

                <div>
                    <Table
                        head={['Session id', 'Message', 'Timestamp (CET)']}
                        keys={['sessionId', 'message', 'timestamp']}
                        data={data}
                        page={page}
                        Pagination={true}
                        limit={LIMIT}
                        handlePageChange={handlePageChange}
                        totalCount={totalCount}
                    />
                </div>
            </div>
        </div>
    );
};

export default Ocpilogs;
